export enum RootRoutes {
  Companies = 'companies',
  Users = 'users',
  Procedures = 'procedures',
  Collaboration = 'collaboration',
  Analytics = 'analytics',
  Licenses = 'licenses',
  Download = 'resources',
  Profile = 'profile',
  Groups = 'groups',
  PairedDevices = 'paired-devices',
}

export enum AuthRoutes {
  Login = 'login',
  Register = 'register',
  ForgotPassword = 'forgot-password',
  SetPassword = 'set-password',
  Pair = 'pair',
}

export class RoutePaths {
    static readonly root = '/';
    static readonly companies: string = `${RootRoutes.Companies}`;
    static readonly users: string = `${RootRoutes.Users}`;
    static readonly usersNeoAnalytics: string = `${RootRoutes.Users}/analytics/:id`;
    static readonly usersNeoAnalyticsExecution: string = `${RootRoutes.Users}/analytics/:id/executions/:executionId`;
    static readonly userSummary: string = `${RootRoutes.Users}/analytics/:id/insights`;
    static readonly groups: string = `${RootRoutes.Groups}`;
    static readonly groupNeoAnalytics: string = `${RootRoutes.Groups}/analytics/:id`;
    static readonly groupNeoAnalyticsExecution: string = `${RootRoutes.Groups}/analytics/:id/executions/:executionId`;
    static readonly procedures: string = `${RootRoutes.Procedures}`;
    static readonly proceduresNeoAnalytics: string = `${RootRoutes.Procedures}/analytics/:id`;
    static readonly proceduresNeoAnalyticsExecution: string = `${RootRoutes.Procedures}/analytics/:id/executions/:executionId`;
    static readonly procedureSummary: string = `${RootRoutes.Procedures}/analytics/:id/insights`;
    static readonly collaboration: string = `${RootRoutes.Collaboration}`;
    static readonly analytics: string = `${RootRoutes.Analytics}`;
    static readonly analyticsLegacy: string = `${RootRoutes.Analytics}/legacy`;
    static readonly licenses: string = `${RootRoutes.Licenses}`;
    static readonly download: string = `${RootRoutes.Download}`;
    static readonly analyticsByUser: string = `${RootRoutes.Analytics}/:id`;
    static readonly profile: string = `${RootRoutes.Profile}`;
    static readonly login: string = `${AuthRoutes.Login}`;
    static readonly register: string = `${AuthRoutes.Register}`;
    static readonly forgotPassword: string = `${AuthRoutes.ForgotPassword}`;
    static readonly setPassword: string = `${AuthRoutes.SetPassword}`;
    // Where a headset sends the user to approve a pairing code (RFC 8628 verification_uri).
    // The identity service builds this URL from WeavrManagerUIUrl, so the two must agree.
    static readonly pair: string = `${AuthRoutes.Pair}`;
    // The administrator's view over everybody's paired devices. Reached from the profile menu
    // rather than the sidebar: it is an occasional housekeeping task, not a daily destination.
    static readonly pairedDevices: string = `${RootRoutes.PairedDevices}`;
}
